export default __webpack_public_path__ + "static/media/TechBlog.85662120.png";